<template>
  <footer class="footer-component">
    <div class="footer-content">
      <span>© 2026 哨兵安全监控管理系统</span>
      <span class="footer-divider">·</span>
      <span>杭州众地科技有限公司</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

<style scoped lang="css">
.footer-component {
  flex-shrink: 0;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #1C2A4A 0%, #131E38 100%);
  color: rgba(255, 255, 255, 0.55);
  font-size: 12px;
  letter-spacing: 0.5px;
}

.footer-content {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  padding: 0 20px;
  white-space: nowrap;
  overflow: hidden;
}

.footer-divider {
  color: var(--border-dark);
}
</style>
